import { render } from "./Bluesky.vue?vue&type=template&id=36f770fd"
import script from "./Bluesky.vue?vue&type=script&lang=js"
export * from "./Bluesky.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__